module.exports = __webpack_public_path__ + "img/tron (28).c4e22baf.jpg";